import cx from 'classnames';
import styles from 'partials/overlay.module.scss';

export const Overlay = ({ className, onClick, isOpen }) => {
	const overlayClass = cx(styles.overlay, className, {
		[styles.open]: isOpen,
		[styles.closing]: !isOpen
	});

	return (
		<div role="presentation" className={overlayClass} onClick={onClick} />
	);
};
